import React from "react";

import Card from "@mui/material/Card/Card";
import CardActionArea from "@mui/material/CardActionArea/CardActionArea";
import CardContent from "@mui/material/CardContent/CardContent";
import { getAlbumName } from "../../../shared/models/album/utils";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../core/components/Layout/components/Main/components/AppRouter/routes";

export function AlbumCard({ album }: { album: any }): JSX.Element {
  const navigate = useNavigate();

  const goToUpdateAlbum = React.useCallback(() => {
    navigate(ROUTES.STICKERS + "/" + album.id);
  }, [album.id, navigate]);

  return (
    <Card
      key={album.id}
      style={{
        backgroundColor: album.color,
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <CardActionArea onClick={goToUpdateAlbum}>
        <CardContent>
          <span className={styles["album-card-title"]}>
            {getAlbumName({ albumId: album.id })}
          </span>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
